import React, {Component} from 'react';
import {
    Dialog, DialogActions, DialogContent,
    Divider,
    Button
} from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import {DragDropContext} from 'react-beautiful-dnd';
import {set, push} from 'object-path-immutable'
import _ from 'lodash';
import ListDesignerHoc from "../../../../../HocHelpers/ListDesignerHoc";
import SourceColumns from "./ColumnsComponents/SourceColumns/SourceColumns";
import TableColumns from "./ColumnsComponents/Columns/TableColumns";
import SortColumns from "./ColumnsComponents/SortColumns";
import FilterColumns from "./ColumnsComponents/FilterColumns";
import PredefinedFilter from "./ColumnsComponents/PredefinedFilter";
import PivotWrapper from "./ColumnsComponents/Pivot/PivotWrapper";
import {
    reorder,
    copy,
    copySort,
    copyValues,
    checkForDroppedColumns,
    orderedColumns, copyFromColumns,
    generatePredefinedFilter
} from './lib';

const styles = () => ({
    wrapper: {
        display: 'flex',
        height: '100%',
        justifyContent: 'start'
    },
    wrapperSortFilter: {
        // width: 550,
        flexDirection: "column",
        alignSelf: 'start',
        margin: '0 10px 0 0'
    },
    columns: {
        width: 250,
        height: 514
    },
    sourceColumns: {
        width: 220,
        height: 514
    }
});

class Columns extends Component {
    constructor(props) {
        super(props);
        this.state = {
            columns: [],
            sourceColumns: [],
            filterColumns: [],
            predefinedFilter: [],
            predefinedFilterAdvanced: [],
            sortColumns: [],
            predefinedColumns: [],
            rowsColumns: [],
            valuesColumns: [],
            pivotColumns: []
        }
    }

    componentDidMount() {
        const {columns} = this.props;
        this.setState({sourceColumns: columns})
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {columns, data} = this.props;
        const {columns: prevColumns, data: prevData} = prevProps;
        const sourceColumns = data.columns;
        if (data !== prevData) {
            this.setState({
                columns: data.columns || [],
                filterColumns: data.filterFields || [],
                predefinedFilter: data.predefinedFilter || [],
                predefinedFilterAdvanced: generatePredefinedFilter(data.predefinedFilter, data.columns) || [],
                sortColumns: data.sort || [],
                rowsColumns: data.rows || [],
                valuesColumns: data.values || [],
                pivotColumns: data.pivotColumns || []
            })
        }

        if (columns !== prevColumns) {
            let copyColumns = [...columns];
            let copySourceColumns = sourceColumns ? [...sourceColumns] : [];
            let orderedCols = orderedColumns(copyColumns);
            this.setState({sourceColumns: checkForDroppedColumns(orderedCols, copySourceColumns)})
        }
    }

    changeDirection = (event, index, direction) => {
        const {sortColumns} = this.state;
        const newSortColumns = set(sortColumns, `${index}.direction`, direction === 'ASC' ? 'DESC' : 'ASC');
        this.setState({sortColumns: newSortColumns});
        event.stopPropagation();
    };

    checkBoxChange = (event, column) => {
        const {columns, filterColumns, sortColumns, sourceColumns} = this.state;
        if (event.target.checked === true) {
            //add to columns
            let newItem = {
                name: column.name,
                label: column.label,
                type: column.type,
                entity: column.entity,
                parentType: column.parentType
            };
            const newColumns = set(columns, columns.length, newItem);
            this.setState({
                columns: newColumns,
                sourceColumns: checkForDroppedColumns(sourceColumns, newColumns)
            })
        } else {
            let newColumns = columns.filter(item => item.name !== column.name);
            let newFilterColumns = filterColumns.filter(item => item.name !== column.name);
            let newSortColumns = sortColumns.filter(item => item.field !== column.name);
            let newSourceColumns = checkForDroppedColumns(sourceColumns, newColumns);
            this.setState({
                sourceColumns: newSourceColumns,
                columns: newColumns,
                filterColumns: newFilterColumns,
                sortColumns: newSortColumns
            })
            //remove from columns, filterColumns, sortColumns
        }
    };

    onSelectAll = (event) => {
        const {sourceColumns} = this.state;
        if (event.target.checked === true) {
            let newColumns = [];
            sourceColumns.forEach(item => newColumns.push({
                label: item.label,
                name: item.name,
                type: item.type,
                entity: item.entity
            }));
            this.setState({columns: newColumns, sourceColumns: checkForDroppedColumns(sourceColumns, newColumns)})
        } else {
            this.setState({
                columns: [],
                sourceColumns: checkForDroppedColumns(sourceColumns, []),
                sortColumns: [],
                filterColumns: [],
                predefinedColumns: []
            })
        }
    };


    onApply = async (event) => {
        const {
            columns,
            filterColumns,
            sortColumns,
            rowsColumns,
            valuesColumns,
            pivotColumns,
            predefinedFilter
        } = this.state;
        const {setColumns, close} = this.props;
        let newColumns = [], newFilterColumns = [], newSortColumns = [], newRowsColumns = [], newValuesColumns = [],
            newPivotColumns = [], newPredefinedFilter = Object.assign(predefinedFilter, {});
        columns.forEach(i => newColumns.push({
            name: i.name,
            label: i.label,
            type: i.type,
            width: i.width,
            hidden: i.hidden,
            format: i.format,
            conditionalFormat: i.conditionalFormat,
            entity: i.entity,
            parentType: i.parentType,
            calculable: i.calculable,
            script: i.script,
            presentation: i.presentation,
            systemUsed: i.systemUsed,
            className: i.className,
            sticky: i.sticky,
            sortable: i.sortable,
            quickSearch: i.quickSearch,
            ignoreTimezoneConversion: i.ignoreTimezoneConversion
        }));
        filterColumns.forEach(i => newFilterColumns.push({
            name: i.name,
            label: i.label,
            type: i.type,
            required: i.required,
            operands: i.operands,
            entity: i.entity
        }));
        sortColumns.forEach(i => newSortColumns.push({field: i.field, direction: i.direction}));
        rowsColumns.forEach(i => {
            let sourceColumn = _.find(newColumns, (o) => o.name === i.name);
            if (sourceColumn) {
                newRowsColumns.push(sourceColumn)
            }
        });
        valuesColumns.forEach(i => newValuesColumns.push({
            field: i.field,
            calculationType: i.calculationType,
            label: i.label,
            width: i.width,
            format: i.format
        }));
        pivotColumns.forEach(i => {
            let sourceColumn = _.find(newColumns, (o) => o.name === i.name);
            if (sourceColumn) {
                newPivotColumns.push(sourceColumn)
            }
        });


        //remove last filter value if it empties
        const lastFilter = predefinedFilter[predefinedFilter.length - 1];

        if (lastFilter && !lastFilter.field) {
            //remove last filter because its empty
            if (predefinedFilter.length > 1 && !lastFilter.or && !lastFilter.and) {
                newPredefinedFilter.splice(predefinedFilter.length - 1, 1);
            }

            if(predefinedFilter.length === 1 && !predefinedFilter[0].field) {
                newPredefinedFilter = [];
            }
        }

        //TODO make validation before set columns
        // 1. if rows or values defined, should be required to present both of these
        setColumns(newColumns, newFilterColumns, newSortColumns, newRowsColumns, newValuesColumns, newPivotColumns, newPredefinedFilter);
        close();
        event.stopPropagation();
    };

    setColumnProps = (column, index) => {
        const {columns} = this.state;
        const newValues = set(columns, `${index}`, column);
        this.setState({columns: newValues})
    };
    createColumnProps = (column) => {
        const {columns} = this.state;
        const newValues = set(columns, `${columns.length}`, column);
        this.setState({columns: newValues})
    };
    removeColumn = (index) => {
        const {sourceColumns, columns} = this.state;
        const newValues = columns.filter(((f, i) => {
            return i !== index
        }));
        const newSourceColumns = checkForDroppedColumns(sourceColumns, newValues);
        this.setState({columns: newValues, sourceColumns: newSourceColumns})
    };

    setFilterProps = (column, index) => {
        const {filterColumns} = this.state;
        const newValues = set(filterColumns, `${index}`, column);
        this.setState({filterColumns: newValues})
    };
    createFilterProps = (column) => {
        const {filterColumns} = this.state;
        const newValues = push(filterColumns, '', column);
        this.setState({filterColumns: newValues})
    };
    removeFilterProps = (column, index) => {
        const {filterColumns} = this.state;
        const newValues = filterColumns.filter((f, i) => i !== index);
        this.setState({filterColumns: newValues})
    };

    // predefined filter handlers
    onChangeValue = (value) => {
        this.setState({predefinedFilter: value});
    };

    setValuesProps = (column, index) => {
        const {valuesColumns} = this.state;
        const newValues = set(valuesColumns, `${index}`, column);
        this.setState({valuesColumns: newValues})
    };

    setPivotColumnsProps = (column, index) => {
        const {pivotColumns} = this.state;
        const newValues = set(pivotColumns, `${index}`, column);
        this.setState({pivotColumns: newValues})
    };

    onDragEnd = (result) => {
        const {
            sourceColumns,
            columns,
            filterColumns,
            sortColumns,
            predefinedColumns,
            rowsColumns,
            valuesColumns,
            pivotColumns
        } = this.state;
        const {destination, source, draggableId} = result;
        if (!destination) {
            return;
        }
        const isDroppedFilterColumns = source.droppableId === 'columns' && destination.droppableId === 'filterColumns';
        const isDroppedSortColumns = source.droppableId === 'columns' && destination.droppableId === 'sortColumns';
        const isDroppedPredefined = source.droppableId === 'columns' && destination.droppableId === 'predefinedColumns';
        const isDroppedRowsColumns = source.droppableId === 'columns' && destination.droppableId === 'rowsColumns';
        const isDroppedValuesColumns = source.droppableId === 'columns' && destination.droppableId === 'valuesColumns';
        const isDroppedPivotColumns = source.droppableId === 'columns' && destination.droppableId === 'pivotColumns';
        const isDroppedColumns = source.droppableId === 'source' && destination.droppableId === 'columns';
        const isRemoving = destination.droppableId === 'sourceItems';
        const isRemovingPivot = (destination.droppableId === 'columns')
            && (source.droppableId === 'pivotColumns' ||
                source.droppableId === 'valuesColumns' ||
                source.droppableId === 'rowsColumns' ||
                source.droppableId === 'sortColumns' ||
                source.droppableId === 'predefinedColumns' ||
                source.droppableId === 'filterColumns');
        if (isRemovingPivot) {
            let newItem,
                newRowsColumns,
                newValuesColumns,
                newPivotColumns,
                newPredefinedColumns,
                newFilterColumns,
                newSortColumns;
            switch (source.droppableId) {
                case 'rowsColumns':
                    newItem = rowsColumns[source.index];
                    newRowsColumns = rowsColumns.filter(item => item.name !== newItem.name);
                    this.setState({rowsColumns: newRowsColumns});
                    return;
                case 'valuesColumns':
                    newItem = valuesColumns[source.index];
                    newValuesColumns = valuesColumns.filter(item => item.field !== newItem.field);
                    this.setState({valuesColumns: newValuesColumns});
                    return;
                case 'pivotColumns':
                    newItem = pivotColumns[source.index];
                    newPivotColumns = pivotColumns.filter(item => item.name !== newItem.name);
                    this.setState({pivotColumns: newPivotColumns});
                    return;
                case 'filterColumns':
                    newItem = filterColumns[source.index];
                    newFilterColumns = filterColumns.filter(item => item.name !== newItem.name);
                    this.setState({filterColumns: newFilterColumns});
                    return;
                case 'sortColumns':
                    newItem = sortColumns[source.index];
                    newSortColumns = sortColumns.filter(item => item.field !== newItem.field);
                    this.setState({sortColumns: newSortColumns});
                    return;
                case 'predefinedColumns':
                    newItem = predefinedColumns[source.index];
                    newPredefinedColumns = predefinedColumns.filter(item => item.name !== newItem.name);
                    this.setState({sortColumns: newPredefinedColumns});
                    return;
                default:
                    return null;
            }
        }
        if (isRemoving) {
            let newItem,
                newColumns,
                newFilterColumns,
                newSortColumns,
                newSourceColumns;
            if (source.droppableId === 'columns') {
                newItem = columns[source.index];
                newColumns = columns.filter(item => item.name !== newItem.name);
                newFilterColumns = filterColumns.filter(item => item.name !== newItem.name);
                newSortColumns = sortColumns.filter(item => item.field !== newItem.name);
                newSourceColumns = checkForDroppedColumns(sourceColumns, newColumns);
                this.setState({
                    sourceColumns: newSourceColumns,
                    columns: newColumns,
                    filterColumns: newFilterColumns,
                    sortColumns: newSortColumns,
                });
                return;
            } else {
                return null;
            }
        }
        if (isDroppedFilterColumns) {
            this.setState((state) => ({
                filterColumns: copyFromColumns(state.columns, state.filterColumns, source, destination)
            }));
            return;
        }

        if (isDroppedPredefined) {
            this.setState((state) => ({
                predefinedColumns: copyFromColumns(state.columns, state.predefinedColumns, source, destination)
            }));
            return;
        }

        if (isDroppedSortColumns) {
            this.setState((state) => ({
                sortColumns: copySort(state.columns, state.sortColumns, source, destination)
            }));
            return;
        }

        if (isDroppedRowsColumns) {
            this.setState((state) => ({
                rowsColumns: copyFromColumns(state.columns, state.rowsColumns, source, destination)
            }));
            return;
        }
        if (isDroppedValuesColumns) {
            this.setState((state) => ({
                valuesColumns: copyValues(state.columns, state.valuesColumns, source, destination)
            }));
            return;
        }
        if (isDroppedPivotColumns) {
            this.setState((state) => ({
                pivotColumns: copyFromColumns(state.columns, state.pivotColumns, source, destination)
            }));
            return;
        }
        if (isDroppedColumns) {
            let newColumns = copy(this.state.sourceColumns, this.state.columns, draggableId, destination);
            this.setState((state) => ({
                columns: newColumns,
                sourceColumns: checkForDroppedColumns(state.sourceColumns, newColumns)
            }));
            return;
        }

        if (source.droppableId === destination.droppableId && source.droppableId !== 'source') {
            this.setState((state) => ({
                [source.droppableId]: reorder(state[source.droppableId], source.index, destination.index)
            }));

        }
    };


    render() {
        const {classes, open, close, data, getColumns, onChangePivotGrandTotal} = this.props;
        const {
            sourceColumns,
            columns,
            filterColumns,
            sortColumns,
            rowsColumns,
            valuesColumns,
            pivotColumns,
            predefinedFilter
        } = this.state;
        return (
            <Dialog
                open={open}
                onClose={close}
                maxWidth={"lg"}
                fullWidth={true}
            >
                <DialogContent>
                    <DragDropContext onDragEnd={this.onDragEnd}>
                        <div className={classes.wrapper}>
                            <div className={classes.sourceColumns}>
                                <SourceColumns sourceColumns={sourceColumns}
                                               data={data}
                                               getColumns={getColumns}
                                               columns={columns}
                                               onSelectAll={this.onSelectAll}
                                               checkBoxChange={this.checkBoxChange}/>
                            </div>
                            <div className={classes.columns}>
                                <TableColumns
                                    setColumnProps={this.setColumnProps}
                                    createColumnProps={this.createColumnProps}
                                    removeColumn={this.removeColumn}
                                    columns={columns}
                                />
                            </div>
                            <div className={classes.wrapperSortFilter}>
                                <PivotWrapper
                                    rowsColumns={rowsColumns}
                                    pivotColumns={pivotColumns}
                                    sourceColumns={sourceColumns}
                                    valuesColumns={valuesColumns}
                                    data={data}
                                    onChangePivotGrandTotal={onChangePivotGrandTotal}
                                    setPivotColumnsProps={this.setPivotColumnsProps}
                                    setValuesProps={this.setValuesProps}
                                />
                                <div style={{display: 'flex'}}>
                                    <div style={{width: '50%'}}>
                                        <FilterColumns
                                            filterColumns={filterColumns}
                                            setFilterProps={this.setFilterProps}
                                            createFilterProps={this.createFilterProps}
                                            removeFilterProps={this.removeFilterProps}
                                            sourceType={data.source && data.source.type}
                                        />
                                    </div>
                                    <div style={{width: '50%'}}>
                                        <SortColumns
                                            sourceColumns={sourceColumns}
                                            sortColumns={sortColumns}
                                            changeDirection={this.changeDirection}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <PredefinedFilter
                                        predefinedFilter={predefinedFilter}
                                        onChangeValue={this.onChangeValue}
                                        listId={data.id}
                                        connector={data.source}
                                    />
                                </div>
                            </div>
                        </div>
                    </DragDropContext>
                </DialogContent>
                <Divider/>
                <DialogActions>
                    <Button color={"primary"} variant={"contained"} size={"small"} onClick={this.onApply}>Apply</Button>
                    <Button color={"default"} variant={"contained"} size={"small"} onClick={close}>Cancel</Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default ListDesignerHoc(withStyles(styles)(Columns));
